var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('partial-header'),_c('router-view',{key:_vm.$route.fullPath,attrs:{"name":"rv-container"}}),(!_vm.isPopupLayout)?_c('partial-footer'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }